import { Navigate } from "react-router-dom";
import { hasPermission } from "../utils/AuthorizeNavigation/authorizeNavigation2";
import PropTypes from "prop-types";

// its become dynamic routing 
//it is take ComponentNavigation and check which is permited and put it in last  
 const RedirectToFirstPermittedChild = ({ routes }) => {
    const firstPermitted = routes.find(r => hasPermission(r.securityKey));
    return <Navigate to={firstPermitted?.path || "/pageNotFound"} replace />;
  };

  RedirectToFirstPermittedChild.propTypes = {
    routes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        path: PropTypes.string.isRequired,
        exact: PropTypes.bool,
        title: PropTypes.string,
        component: PropTypes.elementType,
        securityKey: PropTypes.string.isRequired,
      })
    ).isRequired,
  };

  export default RedirectToFirstPermittedChild;